export let ArticulosPaginationComponent = {
    selector: 'articulosPagination',
    template: require('./articulosPagination.html'),
    bindings: {
        totalPages: '=',
        currentPage: '='
    },
    controller: class {

        /*@ngInject*/
        constructor($scope) {
            Object.assign(this, {$scope});
        }

        $onInit(){

        }

        changePage(number) {
            this.$scope.$emit('setPageTo', number);
        }

        pageRange() {
            const range = [];

            for (let i = 0; i < this.totalPages; i++) {
                range.push(i + 1);
            }
            return range;
        }

    }
};


// WEBPACK FOOTER //
// ./client/components/articulos-pagination/articulosPagination.js